import { useCallback, useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowIosDownOutline } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';
import SingleSelectFilter from '@/components/FilterManager/SingleSelectFilter';

import { RelativeDateFilterOperatorEnumSM } from '../types';
import { getOffsetRelationOptions } from '../utils';

type OffsetRelationSelectorProps = {
  offsetRelation?: RelativeDateFilterOperatorEnumSM;
  onChange: (val: RelativeDateFilterOperatorEnumSM) => void;
};

const OVERRIDES = {
  PopoverContent: {
    minWidth: 15.2,
  },
};

export default function OffsetRelationSelector(props: OffsetRelationSelectorProps) {
  const { offsetRelation, onChange } = props;
  const { t } = useTranslation();
  const onOffsetRelationChange = useCallback(
    (val: string) => {
      onChange(val as RelativeDateFilterOperatorEnumSM);
    },
    [onChange],
  );
  const options = useMemo(() => getOffsetRelationOptions(t), [t]);
  const selectedOptions = options.find((option) => option.id === offsetRelation);

  return (
    <SingleSelectFilter
      defaultSortBy={offsetRelation}
      items={options}
      overrides={OVERRIDES}
      onChange={onOffsetRelationChange}>
      <Stack
        alignItems="center"
        className="h-40 w-full rounded-8 border border-field pe-12 ps-16"
        gapX={8}
        justifyContent="between">
        <Typography variant="body-short-02">{selectedOptions?.label}</Typography>
        <ArrowIosDownOutline className="h-20 w-20" fillColorToken="icon-secondary" />
      </Stack>
    </SingleSelectFilter>
  );
}
